import { render, staticRenderFns } from "./SelectLanguages.vue?vue&type=template&id=7bc46baf&"
import script from "./SelectLanguages.vue?vue&type=script&lang=js&"
export * from "./SelectLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports